import { Route, Routes } from 'react-router-dom';

import { useWorkspaceContext } from '../../../context';
import ValidateEnterprisePlan from '../components/ValidateEnterprisePlan';

export const PaymentRoutes = () => {
  const workspace = useWorkspaceContext();
  const owns = workspace.owns;

  return (
    <Routes>
      <Route path="purchase" element={owns ? <ValidateEnterprisePlan /> : <></>} />
    </Routes>
  );
};
